"use strict";
// non standard rpc used by tronweb-from-provider package
// import { signTronTransaction } from "@opentron/tron-sig-util";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tron_signTransaction = exports.tron_rawJavaTronApiRequest = void 0;
const VALID_METHODS = ["get", "post"];
// pass through an API request to the java-tron API
function tron_rawJavaTronApiRequest([{ method = "get", endpoint, payload }], ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!VALID_METHODS.includes(method)) {
            // todo: use right error...
            throw new Error(`invalid method: ${method}`);
        }
        const reqOpts = {
            method,
            url: endpoint,
            data: method == "post" && Object.keys(payload).length ? payload : null,
            params: method == "get" ? payload : null,
        };
        try {
            const { data } = yield ctx.tronClient.request(reqOpts);
            return data;
        }
        catch (err) {
            // console.log(err.response.data);
            throw err;
        }
    });
}
exports.tron_rawJavaTronApiRequest = tron_rawJavaTronApiRequest;
function tron_signTransaction([unsignedTransaction], ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        // const signedTronTransaction = await signTronTransaction(
        //   unsignedTransaction,
        //   ctx.privateKey
        // );
        // return signedTronTransaction;
        return undefined;
    });
}
exports.tron_signTransaction = tron_signTransaction;
